import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Input } from 'antd';
import DrawerModal from '../../components/shared/DrawerModal';
import { getIsVisibleModal, closeModal } from '../../redux/store/ui/common';
import styles from './UpdateAreaDescriptionModal.styles';
import { useIntl } from 'react-intl';
import {
  selectSelectedArea,
  updateArea,
} from '../../redux/store/appData/areas';

const { TextArea } = Input;

const UpdateAreaDescriptionModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const visibleModal = useSelector(
    getIsVisibleModal('updateAreaDescriptionModal')
  );
  const selectedArea = useSelector(selectSelectedArea);

  const [description, setDescription] = useState<string>('');

  const handleOnSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(updateArea(selectedArea?.id, { description: description.trim() }));
    dispatch(closeModal('updateAreaDescriptionModal'));
  };

  const handleOnCancel = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    dispatch(closeModal('updateAreaDescriptionModal'));
  };

  useEffect(() => {
    setDescription(selectedArea?.description || '');
  }, [visibleModal, selectedArea?.description]);

  return (
    <>
      <DrawerModal
        visible={visibleModal}
        onClose={() => {
          dispatch(closeModal('updateAreaDescriptionModal'));
        }}
      >
        <div className="update-area-description-modal">
          <div className="update-area-description-wrapper">
            <p className="label">
              {intl.formatMessage({
                id: `fleetadmin.area.description`,
                defaultMessage: 'Area description',
              })}
            </p>
            <TextArea
              className="text-area"
              rows={4}
              placeholder={intl.formatMessage({
                id: `fleetadmin.area.description.placeholder`,
                defaultMessage: 'Enter a description for this area',
              })}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <Button
            className="submit-button"
            onClick={handleOnSubmit}
            disabled={
              description.trim() === (selectedArea?.description || '').trim()
            }
          >
            {intl.formatMessage({
              id: `submit`,
            })}
          </Button>
          <Button className="cancel-button" onClick={handleOnCancel}>
            {intl.formatMessage({
              id: `cancel`,
            })}
          </Button>
        </div>
      </DrawerModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UpdateAreaDescriptionModal;
